import { authAPI } from "../api/auth";
import { useLatestQuery } from "../api/useLatestQuery";
import { useSettings } from "../settings/useSettings";

export const useWhoAmI = () => {
  const settings = useSettings();

  const { data: whoAmI, isFetched } = useLatestQuery(["authAPI.whoAmI"], () =>
    authAPI.whoAmI({})
  );

  const whoAmIReady = isFetched;
  let confirmedNotLoggedIn = whoAmIReady && !!whoAmI?.ok && !whoAmI.id;
  let confirmedLoggedIn = whoAmIReady && !!whoAmI?.ok && !!whoAmI.id;
  const concernId = whoAmI?.concernId;
  const details = whoAmI?.details;

  if (concernId && window.cvpIdConcern !== concernId) {
    throw new Error("concernId mismatch");
  }

  const isProduction = whoAmI.environment.toLowerCase() === "production";

  let confirmedNoProfileInConcern =
    whoAmIReady &&
    !!whoAmI?.ok &&
    !!whoAmI.concernId &&
    !whoAmI.hasProfileInConcern;

  let confirmedHasProfileInConcern =
    whoAmIReady &&
    !!whoAmI?.ok &&
    !!whoAmI.id &&
    !!whoAmI.concernId &&
    !!whoAmI.hasProfileInConcern;

  if (settings.iframe_loginOldPortal) {
    confirmedNoProfileInConcern = true;
    confirmedHasProfileInConcern = false;
    confirmedNotLoggedIn = true;
    confirmedLoggedIn = false;
  }

  return {
    whoAmI,
    isFetched,
    concernId,
    details,
    /** Api call is done, and we know we are logged in with visma connect */
    confirmedLoggedIn,

    /** Api call is done, and we know we are not logged in with visma connect*/
    confirmedNotLoggedIn,

    /**
     * Api call is done, we have a concern, and preciely one of these two are true:
     * 1. User is not logged in with visma connect
     * 2. User is logged in with visma connect, but has no profile in the concern
     */
    confirmedNoProfileInConcern,

    /** Api call is done, user is logged in, we have a concern and the user has a profile in that concern */
    confirmedHasProfileInConcern,
    isProduction,
  };
};
